import { memo } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const ButtonIconOutlineSmall = ({ id, icon, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'disabled:cursor-not-allowed disabled:pointer-events-none bg-fills-white border-[1px] border-solid border-outline-default-secondary flex justify-center items-center hover:border-outline-brand-primary hover:bg-primary-primaryFill disabled:border-outline-default-disable disabled:text-black-low disabled:bg-fills-disable text-black-high',
        'gap-[10px] w-[24px] h-[24px] p-[2px] rounded-[100px]',
        props.className
      )}
    >
      {icon && (
        <div className="w-16 h-16 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default memo(ButtonIconOutlineSmall);
